module.exports = __webpack_public_path__ + "static/media/peachclock.b71982bc.png";